import api from './api';

export default {
    actions: {
        admin_getUsers(_, taskId) {
            return api.getUsers(taskId);
        }
    },
    state: {
    },
    mutations: {
    }
}